import { createAction } from 'redux-actions'

export const LOGIN = 'user/login'
export const LOGOUT = 'user/logout'
export const CHANGE_LANGUAGE = 'user/language/change'
/*
//export const AUTO_LOGIN = 'user/login/auto'
//export const LOGIN_SUCCESS = 'user/login/success'
//export const CHANGE_LANGUAGE_SUCCESS = 'user/language/change/success'
*/
const initialState = {
  name: null,
  auth: null,
  lang: 'en'
}

export default function reducer(state = initialState, action) {
  //console.log({action, state})
  switch (action.type) {
  case LOGIN:           return { ...state, name: action.payload.name, auth: action.payload.level }
  case LOGOUT:          return { ...state, name: null, auth: null  }
  case CHANGE_LANGUAGE: return { ...state, lang: action.payload }
  default:              return state
  }
}

export const login = createAction(LOGIN, user => ({name: user.user, level: user.authority}))
export const logout = createAction(LOGOUT)
export const changeLanguage = createAction(CHANGE_LANGUAGE)
/*
//export const autoLogin = createAction(AUTO_LOGIN)
//export const login = createAction(LOGIN, user => ({ name: user }))
//export const loginSuccess = createAction(LOGIN_SUCCESS, name => ({ name }))
//export const changeLanguage = createAction(CHANGE_LANGUAGE, lang => ({ lang }))
//export const changeLanguageSuccess = createAction(CHANGE_LANGUAGE_SUCCESS)
*/



// WEBPACK FOOTER //
// ./src/state/user.js